import moment from 'moment';
import { requestImageUpload } from '../containers/EditListingPage/EditListingPage.duck';
import { deleteFileAWS, uploadFileAWS } from './api';
import { isArrayLength } from './genericHelpers';
import { showErrorToast } from './toast';
export async function uploadImages({ newFiles, fieldName, dispatch, listingImageConfig }) {
  // Check if newFiles is an array and has at least one file
  if (isArrayLength(newFiles)) {
    for (const file of newFiles) {
      const formData = new FormData();
      formData.append('file', file);

      try {
        const tempId = `${file.name}_${Date.now()}`;
        const response = await dispatch(
          requestImageUpload(
            {
              id: tempId,
              file,
            },
            listingImageConfig
          )
        );
      } catch (error) {
        showErrorToast('error', 'Error uploading file:');
        // Handle upload error
      }
    }
  } else {
  }
}

export async function handleDeleteFile({ file, form, fieldName }) {
  try {
    if (!file) return;
    // Retrieve the current files array from the form state
    const files = form.getState().values?.[fieldName] || [];
    // Filter out the correct file based on the type
    const filteredFiles = files.filter(item => {
      if (item.fileLink) {
        // Compare fileLink when dealing with fileLink objects
        return item.fileLink !== file.fileLink;
      } else {
        // Compare by path or name when dealing with File objects
        return item.path !== file.path && item.name !== file.name;
      }
    });
    if (file?.key) {
      const response = await deleteFileAWS({ key: file.key });
    }
    // Update the form state with the filtered array
    form.change(fieldName, filteredFiles);
  } catch (error) {
    showErrorToast('Error while deleting file');
  }
}
export async function uploadVideoFiles(files, fieldName, form, currentUserId) {
  if (!isArrayLength(files)) return;

  for (const file of files) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('userId', currentUserId);

    try {
      const { data = {} } = await uploadFileAWS(formData);
      const { objectURL, key } = data || {};

      if (objectURL && key) {
        const currentDate = moment().format('MM-DD-YYYY hh:mm:ss');
        const profileVideoList = form.getState().values?.[fieldName] || [];
        const existingProfileVideos = profileVideoList.filter(item => item?.key) || [];

        // Check for duplicates based on 'key' (unique identifier from AWS)
        const isDuplicate = existingProfileVideos.some(item => item.key === key);
        if (isDuplicate) {
          // console.warn(`Duplicate file detected with key: ${key}, skipping upload.`);
          continue; // Skip this iteration if duplicate is found
        }

        // Concatenate the new file with the existing files
        const updatedGymProfileVideo = [
          ...existingProfileVideos,
          {
            fileLink: objectURL,
            date: currentDate,
            name: file.name,
            size: file.size,
            key,
          },
        ];

        // Update the form state with the new files
        form.change(fieldName, updatedGymProfileVideo);
        return updatedGymProfileVideo;
      }
    } catch (error) {
      showErrorToast('Error while uploading videos');
    }
  }
}
